import { imageSchema, multiSelectionOptionalSchema, multiSelectionSchema, notesSchema, numberSchema, objectSchema, stringSchema } from "components/inputs/validationSchema";
import { TFunction } from "i18next";
import * as yup from "yup";

export const fieldNames = {
  countryPairs: "countryPairs",
  visaTypes: "visaTypes",
} as const;

export const duplicateValidation = (t: TFunction) => {
  return yup.object().shape({
    [fieldNames.visaTypes]: multiSelectionSchema(fieldNames.visaTypes, t),
    [fieldNames.countryPairs]: multiSelectionSchema(fieldNames.countryPairs, t),
  });
};
